export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/919746765488?text=Hi,%0A%0AI%20want%20to%20know%20more%20about%20your%20services."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500 text-white flex items-center justify-center shadow-lg shadow-primary-500/30 hover:scale-110 hover:bg-primary-400 transition-all duration-300 cursor-pointer group"
      aria-label="Chat on WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl md:text-3xl"></i>
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full border-2 border-primary-400 animate-ping opacity-20"></span>
      {/* Tooltip */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-foreground-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us!
      </span>
    </a>
  );
}